import { render, staticRenderFns } from "./OutboundOrders.vue?vue&type=template&id=4163fc22&"
import script from "./OutboundOrders.vue?vue&type=script&lang=js&"
export * from "./OutboundOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports